/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import colors from "dashboard-template/assets/theme-dark/base/colors";

const { transparent, grey } = colors;
// types
type Types = any;

const listItem: Types = {
  defaultProps: {
    disableGutters: true,
  },

  styleOverrides: {
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      "&.folder-item-selected": {
        backgroundColor: grey[100],
        "&:hover": {
          backgroundColor: grey[300],
        },
      },
      "&.folder-item": {
        backgroundColor: transparent.main,
        "&:hover": {
          backgroundColor: grey[300],
        },
      },
      "&.file-item": {
        paddingLeft: 4,
        paddingBottom: 1,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: grey[200],
        },
      },
    },
  },
};

export default listItem;
